$(document).ready(function()
{
    var default_color = $('.wi-perfect-gift').find('.color_name');
    var data_color_name = $('.wi-perfect-gift').find('.color_active').attr('data-color-name');
    default_color.text(data_color_name);
    var cart__page = $('.cart__page').length;
    
    $(document).on('click', '.wi-product-add-to-cart', function(e)
    {
        e.preventDefault();
        var variantId = $(this).attr('data-variant-id');
        $this = $(this);
        $.ajax(
        {
            type: 'POST',
            url: '/cart/add.js',
            data:
            {
                quantity: 1,
                id: variantId
            },
            dataType: 'json',
            success: function(response)
            {
                if (cart__page == 1)
                {
                    location.reload();
                }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added',
                {
                    detail:
                    {
                        product: response,
                        addToCartBtn: $this
                    }
                }));
            },
            error: function(error)
            {
                console.error('Error adding product to cart', error);
            }
        });
    })

    $(document).on('click', '.roses_number', function()
    {
        $('.roses_number').removeClass('active');
        $(this).addClass('active');
    });

    $(document).on('click', '.color_image', function()
    {
        $('.color_image').removeClass('color_active');
        $(this).addClass('color_active');
        var color_name = $(this).attr('data-color-name');
        $(this).parents('.select_color').find('.color_name').text(color_name);
    });
    
    // https://roseforever.com/collections/all/24?filter.p.m.custom.color=Pearl+Pink
    $(document).on('click', '.find_roses', function()
    {
        var no_of_roses = $('.roses_number.active').text();
        var rose_color = $('.color_image.color_active').data('color-name');
        window.location.href = "https://roseforever.com/collections/all/"+no_of_roses+'?filter.p.m.custom.color='+rose_color;
    });
    $(document).on('click', '.colors_available', function()
    {
        $('.wi-product_variant.display_color_swatch').removeClass('small--hide');
        $('.product_variant_scroll_none').addClass('small--hide');
    });
});